import User from '@/core/user'
import { navigateToV3 } from '@/core/legacy-auth/gotoV3'

const AuthUser = {}

const SKIP_GET_USER_SETTINGS_FOR_RETURN_URLS = [
  // 'ApprovalDashboard'
]

export default {
  /**
   * Connects to login enpoint
   *
   * @param {object}   data - request payload
   * @param {function} [cb] - callback function
   */
  login(data, cb) {
    /** Set payload as form-data */
    var credentials = new FormData()
    credentials.append('user', data.username)
    credentials.append('pass', data.password)

    return this.$user.login(credentials)
  },

  autoLogin(sk, cb) {
    return this.$user.login.call(this, { sk })
  },

  /**
   * Init user in application with reponse from endpoint
   *
   * @param {object}   response - endpoint response
   */
  async init(response, redirect = true, wait = false) {
    const vm = this
    const authUser = AuthUser
    const route = this.$router.currentRoute

    const skipGetUserSettings = SKIP_GET_USER_SETTINGS_FOR_RETURN_URLS.some(r => (route.query.returnUrl || '').includes(r))

    vm.loginEndpoint = vm.api.$.login

    if (response.sk) {
      /** Store logged in user */
      this.$user.init(response, authUser)
      this.$store.state.isLoggedIn = true

      User.set(authUser)

      if (authUser.type === 'nobody') {
        if (!wait) {
          this.api.get(this.api.$.initLegacy, { params: { sk: response.sk } }) // init legacy app
          skipGetUserSettings
            ? setUserSettings.call(vm, { data: { CompanySettings: {} } }, authUser, response, redirect)
            : this.api.get(this.api.$.settings.my.settings)
                .then(settings => setUserSettings.call(vm, settings, authUser, response, redirect))
        } else {
          await this.api.get(this.api.$.initLegacy, { params: { sk: response.sk } }) // init legacy app
          await this.api.get(this.api.$.settings.my.settings)
            .then(settings => setUserSettings.call(vm, settings, authUser, response, redirect))
        }
      } else {
        this.api.get(this.api.$.settings.my.settings)
          .then(settings => {
            const prevPath = this.$routerHistory.previous().path || ''
            const returnUrl = route.query.returnUrl
            const legacyUrl = prevPath.indexOf('goToPage=') >= 0 ? prevPath : null

            setUserSettings.call(vm, settings, authUser, response, false)

            if (
              window.location.href.indexOf('mfa-setup') === -1 &&
              global.config.layout !== 'mobile'
            ) {
              navigateToV3.call(vm, response.sk, legacyUrl || returnUrl)
            }
          })
      }

      /** Supplier with registration not finished */
    } else if (response.returnUrl) {
      const absoluteUrl = response.returnUrl && response.returnUrl.indexOf('http') > -1

      if (absoluteUrl) {
        global.location.href = response.returnUrl
      }
      /** User not authenticated */
    } else {
      this.$store.state.isLoggedIn = false
    }

    /** Endpoint returned an error */
    if (response.error) {
      this.loginError.message = response.error
    }
  },

  /**
   * Handles enpoint error
   *
   * @param {object} error - endpoint error
   */
  handle(error) {
    console.warn('Error logging user ', error)
  },

  /**
   * Redirects
   *
   */
  auth() {
    const user = User.get()

    /** If not authorized go to login */
    if (user === null || user === undefined) {
      this.$router.push('/login')

      /** If authorized as admin go to admin */
    } else if (typeof user.data !== 'undefined' && user.data && typeof user.data.role_id !== 'undefined' && user.data.role_id === 'ADMIN') {
      this.$router.push('/admin')

      /** If authorized go to home by default */
    } else {
      this.$router.push('/home')
    }
  }
}

export function setUser(response, authUser) {
  authUser = authUser || AuthUser
  this.$user.init(response, authUser)
  this.$store.state.isLoggedIn = true

  User.set(authUser)
}

export function setUserSettings(settings, authUser, response, redirect = true) {
  authUser = authUser || AuthUser
  if (typeof settings.data !== 'object') return

  // delete settings.data.UserLogin
  global.localStorage.setItem('sessionSettings', JSON.stringify(settings.data))
  let evedUserSettingsCopy = {}
  try {
    evedUserSettingsCopy = JSON.parse(global.localStorage.getItem('evedUserSettings'))
  } catch (e) {
    evedUserSettingsCopy = {}
  }

  global.localStorage.setItem('evedUserSettings', JSON.stringify({
    ...evedUserSettingsCopy,
    ...settings.data.CompanySettings
  }))
  this.$user.$.settings = this.$user.settings

  User.checkSession()

  /** Role based routing */
  // if (authUser.type === 'admin') {
  //   // TODO:
  //   // admin old link
  //   // this.$user.logout(true)
  //   const returnUrl = this.$router.currentRoute.query.returnUrl || ''
  //   if (~returnUrl.indexOf('/d')) {
  //     this.$router.push(returnUrl)
  //     return
  //   }
  //   window.location.replace(`${this.api.env}/../?page=admin.MainPage`)
  //   return
  // }
  if (authUser.data && typeof authUser.data.role_id !== 'undefined' && authUser.data.role_id === 'ADMIN') {
    this.$router.push('/admin')
  } else {
    const absoluteUrl = response.returnUrl && response.returnUrl.indexOf('http') > -1

    if (absoluteUrl) {
      global.location.href = response.returnUrl
    } else {
      //
      const returnUrl = this.$router.currentRoute.query.returnUrl
      if (!redirect) return
      if (returnUrl) {
        console.log('going to', returnUrl)

        if (~returnUrl.indexOf('/d')) {
          this.$router.push(returnUrl)
          return
        }

        if (~returnUrl.indexOf('/i')) {
          this.$router.push(returnUrl)
          return
        }

        if (~returnUrl.indexOf('/evedpay')) {
          this.$router.push(returnUrl)
          window.location.reload()
          return
        }

        if (returnUrl.indexOf('http') > -1) {
          global.location.href = returnUrl
          return
        }

        const goToPage = this.$router.currentRoute.query.returnUrl.split('__')[0]
        const tab = this.$router.currentRoute.query.returnUrl.split('__')[1]

        if (goToPage !== '0' && tab !== '0') {
          this.$router.push({
            name: '_allLegacy',
            query: {
              goToPage,
              tab,
              param: this.$router.currentRoute.query.returnUrl.split('__')[2],
              sk: this.$router.currentRoute.query.sk
            }
          })
        } else {
          this.$router.push('/home')
        }
      } else {
        this.$router.push(response.returnUrl || '/home')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/loginService.js